import request from '@utils/request'

const options = {
  TH_WARE: {
    Tbl: "SYS_AGENT_DOC",
    Val: "AGENT_CODE",
    Txt: "AGENT_FNAME",
    Cond: "AGENT_TYPE = '103'"
  },
  SH_WARE: {
    Tbl: "SYS_AGENT_DOC",
    Val: "AGENT_CODE",
    Txt: "AGENT_FNAME",
    Cond: "AGENT_TYPE = '102'"
  }
}

const Combo = function(data, callback) {
  if (typeof data == 'string') {
    var table = '';
    if (options.hasOwnProperty(data)) {
      table = options[data]
    } else {
      table = {
        Tbl: "SYS_COMBO",
        Val: "ITEM_VALUE",
        Txt: "CN_TEXT",
        Cond: "ITEM_ID='" + data + "' and DEL_FLAG=0"
      }
    }
    request.post('System.ashx?action=Combo_List', table, {login:false}).then(response => {
      if (Array.isArray(response)) {
        response.forEach(item => {
          if (item.VALUE) item.value = item.VALUE
          if (item.TEXT) item.name = item.TEXT
        })
      }
      if (typeof callback == 'function') callback(response || []);
    })
  }


}
export default Combo;



// WEBPACK FOOTER //
// ./src/utils/combo.js